module.exports = __webpack_public_path__ + "img/kia.4177cd73.svg";